module.exports = __webpack_public_path__ + "static/img/cara-nezumi-3.4963922.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cara-nezumi-3.svg
// module id = pC6X
// module chunks = 1